import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const NAMES = ['Juan P.', 'María L.', 'Carlos S.', 'Florencia M.', 'Diego R.', 'Lucía G.', 'Martín A.', 'Sofía V.', 'Facundo C.', 'Camila T.'];
const CITIES = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'Bariloche', 'Mar del Plata', 'Salta', 'Neuquén', 'Ushuaia', 'Tandil'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 minutes ago
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: `hace ${randomTime} min`
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(triggerPopup, 10000);
    // Then trigger every 25-45 seconds
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        setTimeout(triggerPopup, Math.random() * 20000 + 25000);
      }
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white rounded-lg shadow-xl border border-stone-200 p-4 flex items-start gap-4" data-id="element-2">
          <div className="bg-emerald-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-3">
            <CheckCircle2 className="w-5 h-5 text-emerald-600" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-stone-900" data-id="element-6">
              {currentPurchase.name} acaba de comprar la guía
            </p>
            <div className="flex items-center gap-3 mt-1 text-xs text-stone-500" data-id="element-7">
              <span className="flex items-center gap-1" data-id="element-8">
                <MapPin className="w-3 h-3" data-id="element-9" />
                {currentPurchase.city}, Argentina
              </span>
              <span data-id="element-10">•</span>
              <span data-id="element-11">{currentPurchase.time}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}